import { Button } from '@/ui/Button/Button';

export const MockPushButton = () => {
  const simulatePush = () => {
    // This simulates a push with ID "000012345"
    window.electron.sendMockedReaderScanResponse(['000012345']);
  };

  return <Button onClick={simulatePush}>Simulate Push Button Press</Button>;
};
